import Campaign from '../src/Campaign/index.tsx';
export default Campaign;
